import { Children, useState } from "react";
import { AddIcon, FormTemplateIcon } from "allIcons";
import {
  BodyContainer,
  ListIconWrapper,
  HeaderContainer,
  ListCard,
  MainButton,
  InputField,
  PrimaryHeading,
  RightMainContainer,
} from "commonUI";
import { t } from "i18next";
import { ModulePrefixes } from "enums";

export default function FormTemplates() {
  const [formtemplates, setFormlist] = useState([
    "Project Brief",
    "[Form Title]",
    "[Form Title]",
    "[Form Title]",
    "[Form Title]",
  ]);
  return (
    <>
      <RightMainContainer>
        <HeaderContainer>
          <PrimaryHeading>Forms</PrimaryHeading>
          <MainButton>
            <AddIcon />
            Add
          </MainButton>
        </HeaderContainer>
        <BodyContainer>
          <InputField placeholder={t("input.search.placeholder")} searchIcon={true} filter={true} />
          {Children.toArray(
            formtemplates.map((task, index) => {
              return (
                <ListCard
                  data={task}
                  duplicate={true}
                  edit={true}
                  link={`/${ModulePrefixes.TEMPLATE_LIBRARY}/forms/${index}`}
                  strictLink={true}
                  onDuplicate={(data) => {
                    setFormlist(() => [...formtemplates, `Copy of ${data}`]);
                  }}
                  onDelete={() => {
                    setFormlist(() =>
                      formtemplates.filter((item, i) => i !== index)
                    );
                  }}
                  icon={
                    <ListIconWrapper>
                      <FormTemplateIcon fill="white" />
                    </ListIconWrapper>
                  }
                  deleteTitle={t("libraryTemplate.delete.title")}
                  deleteButtonText="Confirm Delete"
                  deleteMessage={t("libraryTemplate.delete.message")}
                />
              );
            })
          )}
        </BodyContainer>
      </RightMainContainer>
    </>
  );
}
